import React from 'react';
import { Link } from 'react-router-dom';
import projectData from '../../data/projects.json';

const ProjectsS2 = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    // Get all projects from JSON and map to required format
    const projects = projectData.projects.map(project => ({
        pImg: require(`../../images/${project.thumbnailImage || project.mainImage}`),
        title: project.title,
        link: `/project-single/${project.slug}`
    }));

    return(
        <section className="wpo-gallery-section wpo-gallery-section-s2 section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12 sortable-gallery">
                        <div className="wpo-gallery-container">
                            {projects.map((project, index) => (
                                <div className="grid" key={index}>
                                    <div className="wpo-gallery-item">
                                        <Link onClick={ClickHandler} to={project.link}>
                                            <img 
                                                src={project.pImg} 
                                                alt={project.title} 
                                                className="img img-responsive"
                                            />
                                            <div className="wpo-gallery-text" >
                                                <h3 style={{ 
                                                    margin: '0',
                                                    textAlign: 'center',
                                                    fontSize: '18px',
                                                    fontWeight: '600'
                                                }}>{project.title}</h3>
                                                <i className="ti-plus" style={{
                                                    fontSize: '20px',
                                                    marginTop: '10px',
                                                    display: 'inline-block'
                                                }}></i>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> 
            </div>
        </section>
    )
}

export default ProjectsS2;